module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "copy-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/SadTaleoftheBr_copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "pref-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_pref1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap1"
    }
  }, [_vm._v("I: The First Blasphemy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap2"
    }
  }, [_vm._v("II: Bastards at Large")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap3"
    }
  }, [_vm._v("III: Night in the Mountains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap4"
    }
  }, [_vm._v("IV: A Lamentable Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap5"
    }
  }, [_vm._v("V: The Other Cheek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap6"
    }
  }, [_vm._v("VI: The Teeth of a Donated Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap7"
    }
  }, [_vm._v("VII: A Cautionary Yarn, Spun for Fathers and Daughters Alike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap8"
    }
  }, [_vm._v("VIII: Enough Distractions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap9"
    }
  }, [_vm._v("IX: Odd Men at Odds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap10"
    }
  }, [_vm._v("X: Fresh Paths and Good Intentions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap11"
    }
  }, [_vm._v("XI: A Humourous Adventure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap12"
    }
  }, [_vm._v("XII: A Telling on the Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap13"
    }
  }, [_vm._v("XIII: The Start of a Tale Already Concluded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap14"
    }
  }, [_vm._v("XIV: The Monotonous Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap15"
    }
  }, [_vm._v("XV: Prophets of the Schism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap16"
    }
  }, [_vm._v("XVI: The Gaze of the Abyss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap17"
    }
  }, [_vm._v("XVII: The Difficult Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap18"
    }
  }, [_vm._v("XVIII: Beards of a Feather")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap19"
    }
  }, [_vm._v("XIX: Like the Beginning, the End of Winter Is Difficult to Gauge in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap20"
    }
  }, [_vm._v("XX: Venetian Heartbreak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap21"
    }
  }, [_vm._v("XXI: The Conflagration of Desires")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap22"
    }
  }, [_vm._v("XXII: Sins of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap23"
    }
  }, [_vm._v("XXIII: Ever Southward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap24"
    }
  }, [_vm._v("XXIV: The Execution of the Grossbarts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap25"
    }
  }, [_vm._v("XXV: The Monotonous Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap26"
    }
  }, [_vm._v("XXVI: The Children’s Crusade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap27"
    }
  }, [_vm._v("XXVII: Rhodes to Gyptland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap28"
    }
  }, [_vm._v("XXVIII: The Rapturous Hunt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap29"
    }
  }, [_vm._v("XXIX: Like the End, the Beginning of Winter Is Difficult to Gauge in the South")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap30"
    }
  }, [_vm._v("XXX: Their Just Reward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_chap31"
    }
  }, [_vm._v("XXXI: The Final Heresy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "bibl-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_bibl1"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "ackn-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_ackn1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "appe-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_appe1"
    }
  }, [_vm._v("Extras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "auth-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_auth1"
    }
  }, [_vm._v("Meet the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "appe-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_appe2"
    }
  }, [_vm._v("Interview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/SadTaleoftheBr_teas1"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("THE COMPANY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ed62ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SadTaleoftheBr_toc.vue
// module id = 66
// module chunks = 0